<button
  buttonTheme="primary"
  buttonType="regular"
  [size]="size()"
  (click)="export.emit()"
  [class.exporting]="exportLoading()"
  class="export-button"
  [style.width]="width()"
>
  <div class="content">
    <ng-icon name="databaseScriptPlus" size="18"></ng-icon>
    <span class="export">{{ dictionaryService.get('Export') }}</span>
  </div>

  <div class="spinner-wrapper">
    <app-loading-spinner size="xs" />
  </div>

  <div class="shadow-layer"></div>
</button>